import { api } from "../../lib/api";
import { Btn } from "../UI";
import { PharmacyPicker } from "./PharmacyPicker";
import { pharmacyAddress } from "./rxShared";
import { Mail, Phone, Store } from "lucide-react";

function GroupCard({ rx, g, i, single, pharmacies, done, canCall, onMode, run }) {
  const ph = g.pharmacy;
  const link = (id) => id && run(() => api.put(`/prescriptions/${rx.id}/pharmacy`, single ? { pharmacy_id: id } : { pharmacy_id: id, line_ids: g.line_ids }), "Pharmacy linked");
  const contact = ph ? [pharmacyAddress(ph), ph.phone || "no phone", ph.email || "no email"].filter(Boolean).join(" · ") : "";
  return (
    <div className="rounded-2xl border border-[#EFEBE0] p-4" data-testid={`rx-pharmacy-group-${i}`}>
      {ph ? <div className="text-sm text-[#3E2723]" data-testid={i === 0 ? "rx-pharmacy-name" : `rx-pharmacy-name-${i}`}><strong>{ph.name}</strong>
        <div className="text-xs text-[#6D4C41]">{contact}</div></div>
        : <p className="text-xs text-[#84675B]">No pharmacy linked yet.</p>}
      {!single && <div className="mt-1 text-[11px] text-[#7B6157]">For: {g.medications.join(", ")}</div>}
      <div className="mt-3 flex flex-wrap items-start gap-2">
        {!done && <div className="w-full max-w-xs"><PharmacyPicker testId={i === 0 ? "rx-link-pharmacy" : `rx-link-pharmacy-${i}`} pharmacies={pharmacies} value=""
          placeholder={ph ? "Change pharmacy" : "Search to link a pharmacy"} onPick={link} /></div>}
        {ph && !done && <Btn variant="outline" data-testid={i === 0 ? "rx-email-btn" : `rx-email-btn-${i}`} disabled={!g.active_line_ids.length} onClick={() => onMode({ kind: "email", group: g })}><Mail size={14} /> Email pharmacy</Btn>}
        {ph && canCall(g) && <Btn variant="outline" data-testid={i === 0 ? "rx-call-btn" : `rx-call-btn-${i}`} onClick={() => onMode({ kind: "call", group: g })}><Phone size={14} /> Log call</Btn>}
      </div>
    </div>
  );
}

/** One card per pharmacy on the prescription: link or change it, email it, or log a call. */
export function RxPharmacyGroups({ rx, pharmacies, onMode, run }) {
  const groups = rx.pharmacy_groups?.length ? rx.pharmacy_groups : [{ pharmacy: null, line_ids: rx.lines.map((l) => l.id), medications: [], active_line_ids: [] }];
  const voided = rx.status === "voided";
  const done = rx.status === "completed" || voided;
  const canCall = (g) => rx.status !== "completed" || g.line_ids.length > g.active_line_ids.length;
  return (
    <div className="space-y-2" data-testid="rx-pharmacy-block">
      <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase text-[#7B6157]"><Store size={12} /> {groups.length > 1 ? `Pharmacies (${groups.length})` : "Pharmacy"}</div>
      {groups.map((g, i) => <GroupCard key={g.pharmacy?.id || `none-${i}`} rx={rx} g={g} i={i} single={groups.length === 1} pharmacies={pharmacies} done={done} canCall={canCall} onMode={onMode} run={run} />)}
    </div>
  );
}
